import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { AdditionalBenefitListItemsExtensionInterface } from '../../../extension/interface/additional-benefit-list-items.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { GiftsAdditionalItemsExtension } from './gifts-additional-items.extension';
import { GiftsBenefitMetadataExtension } from './gifts-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('gifts')
    .add(BenefitMetadataExtensionInterface, new GiftsBenefitMetadataExtension())
    .add(AdditionalBenefitListItemsExtensionInterface, new GiftsAdditionalItemsExtension())
    .build(),
);
